import {config, http} from './__http';

export default {
    getStreet(street, params) {
        http.get(config.baseUrl()+'/address/complete?postalCode='+params.postalCode+'&houseNr='+params.houseNr).then(response => {
            street(response.data);
        }).catch(e => {
            street(e.response);
        });
    },
}


// WEBPACK FOOTER //
// ./src/api/Address.js